import React from "react";
import { NavLink } from "react-router-dom";
import { Nav } from "reactstrap";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";

import logo from "logo.svg";
import { Redirect } from "react-router";
import { projectname } from "variable";

var ps;

function Sidebar(props) {

  //my code
  const isAdmin = localStorage.getItem("njrujBf847hAfkxncmRbjfhy37AdyhbcKn84hdA8hggeras");
  const permission = JSON.parse(localStorage.getItem("permit"));
  const sidebar = React.useRef();
  // verifies if routeName is the one active (in browser input)
  React.useEffect(() => {
    // setPermit(JSON.parse(localStorage.getItem("permit")));

    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(sidebar.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
    }
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
    };
  });

  // console.log('permision',permission[0]);
  return (
    <>
      <div
        className="sidebar"
        data-color={props.bgColor}
        data-active-color={props.activeColor}
      >
        {isAdmin ? (
          <div className="logo">

            <a
              href="/"
              className="simple-text logo-normal"
              rel="noreferrer"
            >
              <strong>{projectname} </strong>
            </a>
          </div>
        ) : (
          ""
        )}
        <div className="sidebar-wrapper" ref={sidebar}>
          {isAdmin ? (
            <Nav>
              {/* {props.routes.map((prop, key) => {
              return(<><p>{prop.pro}     </p></>);
              })} */}
              <li
              // className={
              //   activeRoute(prop.path) + (prop.pro ? " active-pro" : "")
              // }
              >
                <NavLink
                  to="/admin/dashboard"
                  className="nav-link"
                  activeClassName="active"
                >
                  <i className="nc-icon nc-bank" />
                  <p>Dashboard</p>
                </NavLink>
                {permission?.includes("Access Articles") === true ? (
                  <NavLink
                    to="/admin/articles"
                    className="nav-link"
                    activeClassName="active"
                  >
                    <i className="fas fa-newspaper" />
                    <p>Blogs</p>
                  </NavLink>
                ) : null}



                {permission?.includes("Access Tags") === true ? (
                  <NavLink
                    to="/admin/tags"
                    className="nav-link"
                    activeClassName="active"
                  >
                    <i className="fas fa-tags" />
                    <p>Blog Tags</p>
                  </NavLink>
                ) : null}

                {permission?.includes("Access Tags") === true ? (
                  <NavLink
                    to="/admin/faqs"
                    className="nav-link"
                    activeClassName="active"
                  >
                    <i className="fa fa-question-circle" />
                    <p>Blog Faqs</p>
                  </NavLink>
                ) : null}
                {/* 



                {permission?.includes("Access Active Classifieds") === true ? (
                  <NavLink
                    to="/admin/classifieds"
                    className="nav-link"
                    activeClassName="active"
                  >
                    <i className="fas fa-newspaper" />
                    <p>Active Ads</p>
                  </NavLink>
                ) : null}

                {permission?.includes("Access Pending Classifieds") === true ? (
                  <NavLink
                    to="/admin/pending-ads"
                    className="nav-link"
                    activeClassName="active"
                  >
                    <i className="fas fa-newspaper" />
                    <p>Pending Ads</p>
                  </NavLink>
                ) : null}

                {permission?.includes("Access Active Classifieds") === true ? (
                  <NavLink
                    to="/admin/sold-ads"
                    className="nav-link"
                    activeClassName="active"
                  >
                    <i className="fas fa-newspaper" />
                    <p>Sold Ads</p>
                  </NavLink>
                ) : null}

                
                {permission?.includes("Access Makes") === true ? (
                  <NavLink
                    to="/admin/makes"
                    className="nav-link"
                    activeClassName="active"
                  >
                    <i className="fas fa-car" />
                    <p>Makes</p>
                  </NavLink>
                ) : null}

                {permission?.includes("Access Models") === true ? (
                  <NavLink
                    to="/admin/maker-models"
                    className="nav-link"
                    activeClassName="active"
                  >
                    <i className="fas fa-car-side" />
                    <p>Models</p>
                  </NavLink>
                ) : null}

                {permission?.includes("Access Car Enquiry") === true ? (
                  <NavLink
                    to="/admin/enquiry"
                    className="nav-link"
                    activeClassName="active"
                  >
                    <i className="fas fa-question-circle" />
                    <p>Car Enquiry</p>
                  </NavLink>
                ) : null}

                {permission?.includes("Access Contact Us") === true ? (
                  <NavLink
                    to="/admin/contact-us"
                    className="nav-link"
                    activeClassName="active"
                  >
                    <i className="fa fa-id-badge" />
                    <p>Contact Us</p>
                  </NavLink>
                ) : null}

                {permission?.includes("Access Sliders") === true ? (
                  <NavLink
                    to="/admin/sliders"
                    className="nav-link"
                    activeClassName="active"
                  >
                    <i className="fas fa-sliders-h" />
                    <p>Sliders</p>
                  </NavLink>
                ) : null}


                {permission?.includes("Access Sliders") === true ? (
                  <NavLink
                    to="/admin/referrels"
                    className="nav-link"
                    activeClassName="active"
                  >
                    <i className="fas fa-sliders-h" />
                    <p>Referrels</p>
                  </NavLink>
                ) : null}

                {permission?.includes("Access Sliders") === true ? (
                  <NavLink
                    to="/admin/dealers"
                    className="nav-link"
                    activeClassName="active"
                  >
                    <i className="fas fa-sliders-h" />
                    <p>Dealers</p>
                  </NavLink>
                ) : null}

                 */}


                {permission?.includes("Access Category Faqs") === true ? (
                  <NavLink
                    to="/admin/categoryFaqs"
                    className="nav-link"
                    activeClassName="active"
                  >
                    <i className="fa fa-question-circle" />
                    <p>Category Faqs</p>
                  </NavLink>
                ) : null}

                {permission?.includes("Access Categories") === true ? (
                  <NavLink
                    to="/admin/categories"
                    className="nav-link"
                    activeClassName="active"
                  >
                    <i className="fas fa-sitemap" />
                    <p>Categories</p>
                  </NavLink>
                ) : null}
                {permission?.includes("Access TimeSlots") === true ? (
                  <NavLink
                    to="/admin/timeslots"
                    className="nav-link"
                    activeClassName="active"
                  >
                    <i className="fas fa-calendar"></i>
                    <p>TimeSlots</p>
                  </NavLink>
                ) : null}
                {permission?.includes("Access Gender") === true ? (
                  <NavLink
                    to="/admin/genders"
                    className="nav-link"
                    activeClassName="active"
                  >
                    {/* <i className="fas fa-sitemap" /> */}
                    <i className="fas fa-users"></i>
                    <p>Gender</p>
                  </NavLink>
                ) : null}


                {permission?.includes("Access Appointments") === true ? (
                  <NavLink
                    to="/admin/appointments"
                    className="nav-link"
                    activeClassName="active"
                  >
                    <i className="fas fa-calendar"></i>
                    <p>Appointments</p>
                  </NavLink>
                ) : null}
                {/* {permission?.includes("Access Form Infos") === true ? (
                  <NavLink
                    to="/admin/form-info"
                    className="nav-link"
                    activeClassName="active"
                  >
                    <i className="fas fa-sitemap" />
                    <p>Form Infos</p>
                  </NavLink>
                ) : null}

                {permission?.includes("Access Site Setting") === true ? (
                  <NavLink
                    to="/admin/site-setting"
                    className="nav-link"
                    activeClassName="active"
                  >
                    <i className="fas fa-cogs" />
                    <p>Site Setting</p>
                  </NavLink>
                ) : null}



                {permission?.includes("Access User Options") === true ? (
                  <NavLink
                    to="/admin/user-options"
                    className="nav-link"
                    activeClassName="active"
                  >
                    <i className="fas fa-sitemap" />
                    <p>User Options</p>
                  </NavLink>
                ) : null} */}


                {permission?.includes("Access Permissions") === true ? (
                  <NavLink
                    to="/admin/permissions"
                    className="nav-link"
                    activeClassName="active"
                  >
                    <i className="fa fa-lock" />
                    <p>Permissions List</p>
                  </NavLink>
                ) : null}

                {permission?.includes("Access Admins") === true ? (
                  <NavLink
                    to="/admin/admins"
                    className="nav-link"
                    activeClassName="active"
                  >
                    <i className="fa fa-user" />
                    <p>Admins</p>
                  </NavLink>
                ) : null}
              </li>
            </Nav>
          ) : (
            <Redirect to="login-page" />
          )}
        </div>
      </div>
    </>
  );
}

export default Sidebar;
